import React from "react";
import PropTypes from "prop-types";
import { confirmable } from "react-confirm";
import { Modal, Button } from "react-bootstrap";
import { createConfirmation } from "react-confirm";

const messageDlg = ({
    confirmation,
    proceedLabel,
    cancelLabel,
    show,
    proceed,
}) => (
    <div>
        <Modal onHide={() => proceed(false)} show={show} className="pt-5 mt-5">
            <Modal.Body>{confirmation}</Modal.Body>
            <Modal.Footer>
                <Button onClick={() => proceed(true)}>{proceedLabel}</Button>
            </Modal.Footer>
        </Modal>
    </div>
);

messageDlg.propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object, // arguments of your confirm function
};

export function MessageDlg(
    confirmation,
    proceedLabel = "Ok",
    options = {},
    show
) {
    return createConfirmation(confirmable(messageDlg))({
        confirmation,
        proceedLabel,
        ...options,
    });
}
